import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { FiltersContext } from '../FiltersContainer/context'

import Toggle from '../Toggle'
import Tooltip from '../Tooltip'

import messages from './messages'
import { FilterFamilyBase, Header, Title, IconInfo } from './styles'

const FilterFamily = () => {
  const { filters, setFilters } = useContext(FiltersContext)
  const [isActive, setIsActive] = useState()

  useEffect(() => {
    setIsActive(!!filters.family)
  }, [filters.family])

  function handleToggleSwitch(isOn) {
    const { family, ...rest } = filters
    const updatedFilters = isOn ? { ...filters, family: 'true' } : rest

    setFilters(updatedFilters)
  }

  return (
    <FilterFamilyBase>
      <Header>
        <Title>
          <FormattedMessage {...messages.familyFriendly} />{' '}
        </Title>

        <Tooltip
          content={<FormattedMessage {...messages.familyFriendlyHint} tagName="p" />}
          maxContainerWidth={220}
        >
          <IconInfo size={20} />
        </Tooltip>
      </Header>
      <Toggle initialState={isActive} onSwitch={handleToggleSwitch} />
    </FilterFamilyBase>
  )
}

export default FilterFamily
